// 应用的PAASID
let PASSID = "";

// 应用的名称
const appName = "管理员查询";

// 代理环境
let VUE_APP_ENV = parseInt(process.env.VUE_APP_ENV);

let target = "https://xtbgdev.digitalgd.com.cn";

switch (VUE_APP_ENV) {
  case 1:
    target = "https://xtbgdev.digitalgd.com.cn";
    break;
  case 2:
    target = "https://xtbgtest.digitalgd.com.cn";
    PASSID = "pps";
    break;
  case 3:
    target = "https://xtbg.digitalgd.com.cn";
    break;
  case 4:
    target = "https://xtbg.gdzwfw.gov.cn";
    break;
  default:
    target = "https://xtbgtest.digitalgd.com.cn";
    PASSID = "pps";
    break;
}

const host = (PASSID, GATEWAY) => {
  // host
  const HOST = `${PASSID}${GATEWAY}`;

  return HOST;
};

module.exports = {
  PASSID,
  appName,
  VUE_APP_ENV,
  target,
  host,
};
